import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
// import way from '../vue_fun.js'
// Vue.use(way)
import VueEasytable from "vue-easytable";
// 引入样式
import "vue-easytable/libs/theme-default/index.css";
import "vue-easytable/libs/theme-default/ve-pagination.css";
import myUpload from './components/myUpload/my-upload.vue';
Vue.component('myUpload', myUpload)
Vue.use(VueEasytable);
import { VeLocale } from "vue-easytable";
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;
Vue.prototype.$veLocale = VeLocale;
import myUploadTwo from './components/myUpload/my-uploadTwo.vue';
Vue.component('myUploadTwo', myUploadTwo)
import VueCropper from 'vue-cropper' //npm install vue-cropper
Vue.use(VueCropper)
// npm install vue-aplayer --save
// router.beforeEach((to, from, next) => {
//     //debugger
//     if (to.path === '/doLogin') {
//         next();
//     } else {
//         let userid =localStorage.getItem('iuId');
//         if (userid) {
//             next();
//         } else {
//             next('/doLogin');
//         }
//     }
//     const post = localStorage.getItem('iuPost')
//     if(to.path == '/Home/userList' && post == 1){
//         next('/Home');
//     }
// });
// console.log(way)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
